const newEquipment = {
  plant: "Zone",
  equipment: "Erstellen Sie eine neue Ausrüstung",
  backbtn: "Geh zurück",
  equipmentTag: "Ausrüstungs-Tag",
  mechanical: "Gleitringdichtungscode",
  customer: "Kunde",
  equipmentType: "Ausstattungsart",
  typeContract: "Vertragsart",
  equipmentStatus: "Gerätestatus",
  area: "Bereich",
  unit: "Einheit",
  sealTypes: "Gleitringdichtungstypen",
  hazardous: "Gefahrenbereichsklassifizierung",
  createdBy: "Erstellt von",
  dateCreated: "Datum erstellt",
  comment: "Kommentar",
  pumpHousing: "Pumpengehäuse",
  deleteEquipment: "Ausrüstung löschen",
  snackText: "Ihre neue Ausrüstung wurde erstellt",
  submit: "einreichen"
};
export default newEquipment;
